import { Component, OnInit } from "@angular/core";

import { Chart } from "angular-highcharts";
import { LoadingBarService } from "@ngx-loading-bar/core";
import * as _ from "lodash";

import { HeaderService, DashboardService } from "../../shared";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  dateNow;

  chart: Chart;

  chartsData;

  icnClass = [
    "icn-clock one",
    "icn-hourglass two",
    "icn-check tree",
    "icn-close four",
    "icn-warning five",
  ];

  starsRating = {
    initialStars: 0,
  };

  serviceTime = "00:00";

  constructor(
    private headerService: HeaderService,
    private loadingBarService: LoadingBarService,
    private dashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.headerService.changeTitle("Painel de controle visão geral");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(true);

    this.chartsData = {
      categories: [
        "00-02h",
        "02-04h",
        "04-06h",
        "06-08h",
        "08-10h",
        "12-14h",
        "14-16h",
        "16-18h",
        "18-20h",
        "20-22h",
        "22-00h",
      ],
      total: [
        {
          name: "OS em aprovação",
          total: 0,
        },
        {
          name: "OS em andamento",
          total: 0,
        },
        {
          name: "OS atendidas",
          total: 0,
        },
        {
          name: "OS não atendidas",
          total: 0,
        },
        {
          name: "OS divergentes",
          total: 0,
        },
      ],
      series: [
        {
          name: "OS em aprovação",
          data: _.times(11, _.random.bind(1, 1)),
        },
        {
          name: "OS em andamento",
          data: _.times(11, _.random.bind(1, 1)),
        },
        {
          name: "OS atendidas",
          data: _.times(11, _.random.bind(1, 1)),
        },
        {
          name: "OS não atendidas",
          data: _.times(11, _.random.bind(1, 1)),
        },
        {
          name: "OS divergentes",
          data: _.times(11, _.random.bind(1, 1)),
        },
      ],
    };

    let dataAtual = new Date();

    let dataString: string =
      dataAtual.getDate() +
      "/" +
      dataAtual.getMonth() +
      "/" +
      dataAtual.getFullYear();

    this.setDateNow(dataString);
  }

  setDateNow(date) {
    this.dateNow = date;

    this.getDashboard(this.dateNow);
  }

  getDashboard(data) {
    this.loadingBarService.start();

    this.dashboardService.getDashboard(data).subscribe((response) => {
      this.chartsData = response;

      this.chartsData = {
        categories: response["categories"],
        series: response["series"],
        total: response["total"],
      };

      this.chart = new Chart({
        chart: {
          type: "area",
        },
        title: {
          text: undefined,
        },
        subtitle: {
          text: undefined,
        },
        xAxis: {
          categories: this.chartsData.categories,
        },
        yAxis: {
          title: undefined,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: "circle",
              radius: 2,
            },
          },
        },
        series: this.chartsData.series,
        credits: {
          enabled: false,
        },
      });

      this.starsRating.initialStars =
        response["indicadorOsMediaSatisfacaoAtendimento"];

      this.serviceTime = response["indicadorOsTempoMedioAtendimento"];

      this.loadingBarService.complete();
    });
  }

  hideShowSeries(event, seriesId) {
    for (let i = 0; i < event.path.length; i++) {
      let el = event.path[i].className;

      if (el === "content" || el === "content active") {
        event.path[i].classList.toggle("active");
      }
    }

    this.chart.ref$.subscribe((chart) => {
      let visible = !chart.series[seriesId].visible;

      chart.series[seriesId].setVisible(visible);
      // update({
      //   visible: !chart.series[seriesId].visible,
      // });
    });
  }
}
